<template>
  <div class="address-list">
    <the-heading :is-modal="isEcLine027Flag ? false : true" class="lg:mb-8 mb-2">{{
      isEcLine027Flag ? $t('ec-line027.heading') : $t('common.addressList.title')
    }}</the-heading>
    <the-section
      :title="isEcLine027Flag ? $t('ec-line027.content.shippingTitlte') : $t('common.addressList.subTitle')"
      :is-modal="isEcLine027Flag ? false : true"
    >
      <div
        class="flex flex-row flex-wrap w-full special_el-radio"
        :class="{ 'address-list-content': !isEcLine027Flag }"
      >
        <el-radio
          v-for="item in data"
          :key="item.id"
          :label="item.id"
          v-model="value"
          class="radio-dot border-2 border-solid border-table rounded-md p-4 lg:mb-3 mb-1 flex items-center"
          :class="[value === item.id ? 'is-selected' : '', `address-${item.id}`]"
          @change="$emit('input', item.id)"
        >
          <el-col :span="colSpan" class="overflow-hidden">
            <div class="flex flex-col text-base leading-tight ml-1 text-gray-950">
              <span class="font-bold break-words whitespace-normal">{{ getFullName(item) }}</span>
              <span class="break-words whitespace-normal">{{ item.postal_code }}</span>
              <span class="flex-1 break-words whitespace-normal">{{ getFullAddress(item) }}</span>
              <text-ellipsis v-if="item.addr03" class="flex-1 break-words whitespace-normal">{{
                item.addr03
              }}</text-ellipsis>
            </div>
          </el-col>
          <el-col v-if="!corporateFlag" :span="2">
            <el-button
              type="text"
              icon="mdi mdi-chevron-right mdi-36px text-gray-950"
              class="text-xl"
              @click.native="onEditAddr(item.id)"
            ></el-button>
          </el-col>
        </el-radio>
      </div>
      <div v-if="!corporateFlag" class="flex flex-row justify-center mt-3 lg:mt-6">
        <el-button class="list-action--btn" @click="onNewAddr">{{ $t('common.addressList.newAddrBtn') }}</el-button>
      </div>
      <div v-if="!isEcLine027Flag && selectedChanged" class="selected-changed-content">
        <div class="items-center flex">
          <p class="font-medium text-red text-base break-words whitespace-normal mt-2 lg:mt-3">
            {{ $t('common.messages.confirmDeliveryAddressChange.content1') }}<br />
            {{ $t('common.messages.confirmDeliveryAddressChange.content2') }}
          </p>
        </div>
      </div>
      <div v-if="!isEcLine027Flag" class="check-box-section mt-5 lg:mt-10">
        <div v-if="!corporateFlag" class="items-center flex">
          <el-checkbox v-model="addressListCheckboxes.is_update_customer" class="flex items-center">
            <span class="break-words whitespace-normal">
              {{ $t('common.addressList.checkbox.isUpdateCustomer') }}
            </span>
          </el-checkbox>
        </div>
        <div class="items-center" :class="{ 'mt-2 lg:mt-4': !corporateFlag }">
          <el-checkbox v-model="addressListCheckboxes.is_default">
            <span class="items-center break-words whitespace-normal">
              {{ $t('common.addressList.checkbox.isDefaultShipping.label') }}
            </span>
          </el-checkbox>
          <div class="text-xs">{{ $t('common.addressList.checkbox.isDefaultShipping.description') }}</div>
        </div>
      </div>
    </the-section>
    <div v-if="isEcLine027Flag && selectedChanged" class="selected-changed-content">
      <div class="items-center flex justify-center">
        <p class="font-medium text-red text-base break-words whitespace-normal mt-6 lg:mt-10 text-center">
          {{ $t('common.messages.confirmDeliveryAddressChange.content1') }}<br />
          {{ $t('common.messages.confirmDeliveryAddressChange.content2') }}
        </p>
      </div>
    </div>
    <div v-if="isEcLine027Flag && !corporateFlag" class="check-box-section mt-5 lg:mt-10">
      <div class="items-center flex">
        <el-checkbox v-model="addressListCheckboxes.is_update_customer" class="flex items-center">
          <span class="break-words whitespace-normal">
            {{ $t('common.addressList.checkbox.isUpdateCustomer') }}
          </span>
        </el-checkbox>
      </div>
    </div>
    <div class="flex flex-col items-center lg:flex-row justify-center mt-3 lg:mt-6">
      <el-button class="submit-btn lg:ml-6 lg:order-1 whitespace-pre" @click="onSubmit">
        {{ submitText }}
      </el-button>
      <el-button class="cancel-btn mt-5 lg:my-0" @click="onCancel">{{ $t('common.action.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import TextEllipsis from './TextEllipsis.vue'

export default {
  components: { TheSection, TheHeading, TextEllipsis },
  props: {
    isDialog: Boolean,

    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: [String, Number],
      required: false,
      default: () => '',
    },
    subscriptionId: {
      type: [String, Number],
      default: () => '',
    },
    cancel: {
      type: Function,
      required: false,
      default: null,
    },
    submit: {
      type: Function,
      required: false,
      default: null,
    },
    submitText: {
      type: String,
      default: function () {
        return this.$t('ec-line027.content.changeBtn')
      },
    },
    corporateFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedChanged: {
      type: Boolean,
      required: false,
      default: false,
    },
    addressListCheckboxes: {
      type: Object,
      required: false,
      default: () => ({
        is_update_customer: false,
        is_default: false,
      }),
    },
    isEcLine027Flag: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasAddedAddressFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    colSpan() {
      return this.corporateFlag ? 24 : 22
    },
  },
  updated() {
    if (this.hasAddedAddressFlag && !this.isEcLine027Flag) {
      this.scrollToSelectedAddress(this.value)
    }
  },
  mounted() {
    if (!this.isEcLine027Flag) {
      this.scrollToSelectedAddress(this.value)
    }
  },
  methods: {
    getFullAddress(item) {
      return this.Utils.helper.address(item.pref?.name, item.addr01, item.addr02)
    },
    getFullName(item) {
      const storeName = this.corporateFlag ? item.store_name : ''
      return storeName + ' ' + this.Utils.helper.fullName(item.name01, item.name02)
    },
    onEditAddr(id) {
      this.$emit('edit-address', id)
    },
    onNewAddr() {
      this.$emit('add-address')
    },
    async onSubmit() {
      if (this.submit) {
        await this.submit(this.value)
        this.resetShippingPosition()
      }
    },
    onCancel() {
      if (this.cancel) {
        this.cancel()
        this.resetShippingPosition()
      }
    },
    scrollToSelectedAddress(addressId) {
      this.$nextTick(() => {
        const className = `address-${addressId}`
        const selectedElement = document.querySelector(`.${className}`)
        const modalContent = document.querySelector('.address-list-content')

        if (selectedElement && modalContent) {
          const offsetTop = selectedElement.offsetTop - modalContent.offsetTop
          modalContent.scrollTo({
            top: offsetTop,
            behavior: 'auto',
          })
        }
      })
    },
    resetShippingPosition() {
      this.$nextTick(() => {
        const shippingContent = document.querySelector('.shipping-section')

        if (shippingContent) {
          shippingContent.scrollIntoView({ behavior: 'auto', block: 'start' })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/address-list.scss';
</style>
